import { render } from "./ForgetPassword.vue?vue&type=template&id=7d82ad8f"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"

import "./ForgetPassword.vue?vue&type=style&index=0&id=7d82ad8f&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__